/**
 * 请求obj参数转换为queryString
 * @param {*} queryParams 
 */
const toQueryString = function(queryParams) {
    let ret = [];
    for (let key in queryParams) {
        ret.push(key + '=' + queryParams[key]);
    }
    return ret.join('&');
}

/**
 * 获得反爬虫的_token
 * @param {*} url 
 * @param {*} queryParams 
 */
const getRohrToken = function(host, queryParams) {
    if (window.Rohr_Opt && window.Rohr_Opt.reload) {
        const rohr = window.Rohr_Opt;
        let _token = '';
        let queryString = toQueryString(queryParams);

        let _url = location.protocol + host + '?' + queryString;
        rohr.reload(_url);
        try {
            _token = rohr.reload(_url) || '';
        } catch (e) {
            console.log('获取token失败:' + e)
        }
        return _token;
    }
}
module.exports = getRohrToken



// WEBPACK FOOTER //
// ./src/lib/rohr.js